import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'tracking/:taskId',
    loadComponent: () =>
      import('./pages/tracking/tracking.page').then(m => m.TrackingPage)
  },
  {
    path: 'not-found',
    loadComponent: () =>
      import('./pages/not-found/not-found.page').then(m => m.NotFoundPage)
  },
    {
    path: 'delivered',
    loadComponent: () =>
      import('./pages/delivered/delivered.page').then(m => m.DeliveredPage)
  },
  {
    path: ':taskId',
    redirectTo: 'tracking/:taskId',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: 'not-found'
  }
];